export interface HighlightedTextPart {
  highlighted: boolean;
  text: string;
}

// Breaks the text into parts, each part contains a part of the original text and a boolean indicating if it is highlighted.
// It uses a prefix and suffix to parse the text (\/* and *\/).
// This must be configured on the algolia index.
// ex: "Dol/*iprane*/ 500mg" will be split into "Dol" "iprane" and " 500mg"
export const parseHighlightedText = (input: string): HighlightedTextPart[] => {
  const re = /\/\*(.*?)\*\//g;
  let index = 0;
  const parts: HighlightedTextPart[] = [];
  let match: null | RegExpExecArray;
  while ((match = re.exec(input)) != null) {
    const end = match.index + match[0].length;
    parts.push(
      {
        highlighted: false,
        text: input.slice(index, match.index),
      },
      {
        highlighted: true,
        text: input.slice(match.index + 2, end - 2),
      },
    );
    index = end;
  }
  parts.push({
    highlighted: false,
    text: input.slice(index),
  });
  return parts;
};
